module.exports = __webpack_public_path__ + "img/mockup-2.014bc54f.png";